import React, { useEffect, createElement } from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { OfferStack } from './components/OfferStack';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: (...args: any[]) => void;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
    }
    window.fbq('init', '25962343990086349');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen flex flex-col w-full font-body" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainSection data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <OfferStack data-id="element-6" />
        <PricingSection data-id="element-7" />
        <GuaranteeSection data-id="element-8" />
        <FAQSection data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}